import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { averageIssueAgeReportEntrypoint } from '@jira/spa-apps__reports-average-issue-age/src/averageIssueAgeReport.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessAverageIssueAgeRoute } from '@jira/router-routes__business-reports-routes/src/jiraBusinessAverageIssueAgeRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const averageIssueAgePageEntrypoint = createPageEntryPoint({
	main: averageIssueAgeReportEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessAverageIssueAgeRouteEntry: Route = createEntry(
	jiraBusinessAverageIssueAgeRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.reports-average-issue-age',

		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),

		entryPoint: () => averageIssueAgePageEntrypoint,

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
